import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'

Vue.use(Vueaxios, axios)
export default {
  listProduct (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/product/item', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  itemBarcode (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/product/item/barcode', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  itemById (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/product/item/id', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  itemAdd (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/product/item/new', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        // console.log(error.response.data.error)
        error(response.response)
      }
    )
  },
  itemUnit (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/item/unit', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  itemType (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/item/type', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  itemGroup (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/item/group', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  itemDepartment (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/item/department', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  itemCategory (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/item/category', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  itemsALLGroup (URL, header, body, success, error) {
    Vue.axios.get(URL + 'mis/v1/item/search/group', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  createReceive (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/receive/v1/create/receive', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  updateReceive (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/receive/v1/update/receive', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  deleteReceive (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/receive/v1/remove/receive', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  listReceive (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/receive/v1/list/receive', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getReceive (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/receive/v1/get/receive', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  uploadImage (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/item/upload/image', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/service_price_item.js